import { idValues } from 'utils/arrays.js';

function consentItemsByCategory(items) {
  if (!items || !items.list) {
    return null;
  }
  const result = {};
  idValues(items).forEach((item) => {
    const { category } = item;
    const { id } = category;
    if (result[id]) {
      result[id].items.push(item);
    } else {
      result[id] = { ...category, items: [item] };
    }
  });
  return Object.values(result);
}

export default consentItemsByCategory;
